// !!! DO NOT TOUCH !!!
import categories from './assets/configs/categories.json';
import clusters from './assets/configs/clusters.json';
import collectibles from './assets/configs/collectibles.json';
import game from './assets/configs/game.json';
import map from './assets/configs/map.json';
import regions from './assets/configs/regions.json';
import tags from './assets/configs/tags.json';
import { icons } from './assets/icons';

export default {
  categories,
  clusters,
  collectibles,
  icons,
  map,
  regions,
  tags,
  ...game,
};
// !!! DO NOT TOUCH !!!
